import { Outlet, Route, Routes } from 'react-router';

import { AppShell } from './app/components/common/app-shell';
import {
  RequireAdmin,
  RequireAuth,
  RequireFeature,
  RequireGuest,
} from './app/components/common/require-auth';
import { Toaster } from './app/components/ui/sonner';
import { AuthProvider } from './app/hooks/use-auth';
import { PainelSnapshotProvider } from './app/hooks/use-painel-snapshot';
import { SysAdminPage } from './app/routes/sys-admin/sys-admin.page';
import { appRoutes, authRoutes } from './config/routes';

/** Um único `PainelSnapshotProvider` acima das rotas: o snapshot sobrevive à navegação entre telas. */
function AppLayout() {
  return (
    <RequireAuth>
      <PainelSnapshotProvider>
        <AppShell>
          <Outlet />
        </AppShell>
      </PainelSnapshotProvider>
    </RequireAuth>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster richColors position="bottom-right" />
      <Routes>
        {/* Modo a parte, sem RequireAuth/RequireGuest/AppShell -- gerencia a propria sessao. */}
        <Route path="/sys-admin" element={<SysAdminPage />} />
        {authRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<RequireGuest>{route.element}</RequireGuest>}
          />
        ))}
        <Route element={<AppLayout />}>
          {appRoutes.map((route) => {
            let element = route.element;
            if (route.feature) {
              element = <RequireFeature feature={route.feature}>{element}</RequireFeature>;
            }
            if (route.adminOnly) {
              element = <RequireAdmin>{element}</RequireAdmin>;
            }
            return <Route key={route.path} path={route.path} element={element} />;
          })}
        </Route>
      </Routes>
    </AuthProvider>
  );
}
